import ClusterRepo from './catalog.cattle.io.clusterrepo';

export default ClusterRepo;
